import React, { useState } from 'react'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
import { FaCreditCard, FaMoneyBillWave, FaWallet } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { changePaymentMethodInBook, changePaymentMethodInHallBook } from '../../features/home/bookingSlice';
import toast from 'react-hot-toast';
import { changePaymentMethodInBookTrip } from '../../features/home/bookTripSlice';
interface ChangePaymentMethodProps {
    isOpen: boolean;
    onClose: () => void;
    current: string;
    bookId: number
    type: "place" | "trip" | "Hall";
    paymentAvailabel: number[]
}
const PAYMENT_MAP: Record<number, string> = {
    1: 'Cash',
    2: 'Online',
};

const ChangePaymentMethod = ({ isOpen, onClose, current, bookId, type, paymentAvailabel }: ChangePaymentMethodProps) => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const [selectedMethod, setSelectedMethod] = useState('');
    const { user } = useSelector((state: RootState) => state.user);
    const handleConfirm = async () => {
        try {
            await dispatch(
                type === "place" ?
                    changePaymentMethodInBook({
                        bookId,
                        userId: user?.id,
                        paymentMethod: selectedMethod
                    }) : type === "Hall" ?
                        changePaymentMethodInHallBook({
                            bookId,
                            userId: user?.id,
                            paymentMethod: selectedMethod
                        }) :
                        changePaymentMethodInBookTrip({
                            bookId,
                            userId: user?.id,
                            paymentMethod: selectedMethod
                        })
            ).unwrap();

            onClose();
        } catch (error) {
            toast.error("Failed to change payment method:");

        }
    };
    const paymentMethods = [
        {
            key: 'Wallet',
            label: t('myWallet'),
            icon: <FaWallet className="text-2xl text-secondry" />,
            description: (
                <div className="text-xs text-nowrap text-textSecond">
                    {t('available')} = <span className="text-secondry">0.00 LYD</span>
                </div>
            ),
        },
        {
            id: 2,
            key: 'Online',
            label: t('onlinePayment'),
            icon: <FaCreditCard className="text-2xl text-blue-600" />,
        },
        {
            id: 1,
            key: 'Cash',
            label: t('cashPayment'),
            icon: <FaMoneyBillWave className="text-2xl text-green-600" />,
        },
    ];
    const filteredPaymentMethods = paymentMethods.filter(method => {

        if (method.key === current) return false;

        if (paymentAvailabel.length === 0) return true;

        const allowedKeys = paymentAvailabel.map(id => PAYMENT_MAP[id]);
        return allowedKeys.includes(method.key);
    });

    return (
        <Dialog open={isOpen} onClose={onClose} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className="relative z-50">
            <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
            <div className="fixed inset-0 flex items-center justify-center p-4">
                <DialogPanel className="w-full max-w-lg text-black bg-white rounded-xl p-6 shadow-xl">
                    <DialogTitle className="text-lg font-bold mb-4">{t('what-way-need')}</DialogTitle>
                    {/* Payment Method */}
                    {filteredPaymentMethods.length === 0 && (
                        <p className="text-center text-sm text-textSecond mt-4">
                            لا يمكن تغيير طريقة الدفع حالياً
                        </p>
                    )}
                    <div className="grid xs:grid-cols-1 sm:grid-cols-2 grid-cols-3 gap-4">
                        {filteredPaymentMethods.map(method => (
                            <label
                                key={method.key}
                                className={`flex items-center w-full gap-2 p-2 border rounded-lg cursor-pointer transition ${selectedMethod === method.key
                                    ? 'border-secondry bg-orange-50'
                                    : 'border-gray-200'
                                    }`}
                            >
                                <input
                                    type="radio"
                                    name="paymentMethod"
                                    className="accent-secondry focus:outline-none"
                                    checked={selectedMethod === method.key}
                                    onChange={() => setSelectedMethod(method.key)}
                                />
                                {method.icon}
                                <div className="text-sm">
                                    <div className="font-medium">{method.label}</div>
                                    {method.description && method.description}
                                </div>
                            </label>
                        ))}
                    </div>
                    <div className="mt-6">
                        <button
                            onClick={handleConfirm}
                            disabled={!selectedMethod || filteredPaymentMethods.length === 0}
                            className="bg-primary text-white px-6 w-full py-3 rounded-lg hover:scale-105 transition disabled:opacity-50"
                        >
                            {t('confirm')}
                        </button>
                    </div>
                </DialogPanel>
            </div>
        </Dialog>
    )
}

export default ChangePaymentMethod